import { render } from "./account-profile-page.vue?vue&type=template&id=a66effd6&ts=true"
import script from "./account-profile-page.vue?vue&type=script&lang=ts"
export * from "./account-profile-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__